/**
 * Theme Switcher Component
 * Provides UI for switching between light and dark themes
 */

import React from 'react';
import { Toggle, RadioButtonGroup, RadioButton } from '@carbon/react';
import { Light, Asleep } from '@carbon/icons-react';
import { useTheme } from '../../contexts/ThemeContext';

export const ThemeSwitcher: React.FC = () => {
  const { theme, setTheme, isSystemPreference, toggleSystemPreference } = useTheme();

  const handleThemeChange = (value: string) => {
    setTheme(value as 'white' | 'g10' | 'g90' | 'g100');
  };

  return (
    <div className="theme-switcher" style={{ padding: '16px', background: 'var(--cds-layer-02)' }}>
      <div style={{ marginBottom: '16px' }}>
        <Toggle
          id="system-theme-toggle"
          labelText="Use system theme"
          labelA="Manual"
          labelB="System"
          toggled={isSystemPreference}
          onToggle={toggleSystemPreference}
        />
      </div>

      {!isSystemPreference && (
        <RadioButtonGroup
          legendText="Select theme"
          name="theme-selection"
          valueSelected={theme}
          onChange={handleThemeChange}
          orientation="vertical"
        >
          <RadioButton
            labelText={
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Light size={16} />
                Light (White)
              </span>
            }
            value="white"
            id="theme-white"
          />
          <RadioButton
            labelText={
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Light size={16} />
                Light Gray (G10)
              </span>
            }
            value="g10"
            id="theme-g10"
          />
          <RadioButton
            labelText={
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Asleep size={16} />
                Dark Gray (G90)
              </span>
            }
            value="g90"
            id="theme-g90"
          />
          <RadioButton
            labelText={
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Asleep size={16} />
                Dark (G100)
              </span>
            }
            value="g100"
            id="theme-g100"
          />
        </RadioButtonGroup>
      )}

      <div style={{ marginTop: '16px', fontSize: '12px', color: 'var(--cds-text-02)' }}>
        Current theme: <strong>{theme}</strong>
        {isSystemPreference && ' (System Preference)'}
      </div>
    </div>
  );
};

export default ThemeSwitcher;
